export default "__VITE_ASSET__16bc2808__"